import React from "react";
import { connect } from "react-redux";
import { selectRewards } from "../../actions";

import WizardStep from "../WizardStep";
import WizardSidebar from "../WizardSidebar";
import rewardsList from "../../config/rewardsList";
import "../../css/RewardActions.scss";

class RewardActions extends React.Component {
    state = {
        title: "Incentivize your customers",
        text: "Select the six actions you want to reward.",
        rewardsList: rewardsList,
        error: false
    };

    renderRewardsList = () => {
        return this.state.rewardsList.map(reward => {
            return (
                <div
                    className={
                        "single-reward " +
                        (this.isRewardSelect(reward.rewardName) > -1 ? "active" : "")
                    }
                    key={ reward.rewardName }
                    onClick={ () => {
                        this.handlerSelectedReward(reward);
                    } }>
                    <div className="reward-icon">
                        <img
                            className="icon-default"
                            src={ reward.rewardIcon }
                            alt={ reward.rewardName }
                        />
                        <img
                            className="icon-filled"
                            src={ reward.rewardIconFilled }
                            alt={ reward.rewardName }
                        />
                    </div>
                    <div className="reward-description">{ reward.rewardDescription }</div>
                </div>
            );
        });
    };

    handlerSelectedReward = reward => {
        clearTimeout(this.timeout);
        if (
            this.props.selectedRewards.length === 6 &&
            !this.isRewardSelect(reward.rewardName)
        ) {
            this.setState({
                error: true
            });

            this.timeout = setTimeout(() => {
                // Reset the state in order to restart the error animation
                this.setState({
                    error: false
                });
            }, 2500);
            return;
        }

        this.props.selectRewards(reward);
    };

	/**
	 * Check if a reward was selected
	 */
    isRewardSelect = rewardName => {
        for (var i = 0; i < this.props.selectedRewards.length; i++) {
            if (this.props.selectedRewards[i]["rewardName"] === rewardName) {
                return true;
            } else {
                continue;
            }
        }
    };

    render() {
        return (
            <div className="view rewardActions">
                <WizardSidebar
                    title="BUILDING LOYALTY IS A COMPREHENSIVE PROCESS"
                    text={
                        <div>
                            <p>It’s about more than just repeat purchases.</p>
                            <p>
                                Using everything from referrals and rewards, to incentivized actions and VIP tiers, robust Loyalty & Referrals programs allow brands to engage customers across many different levels in order to build lasting relationships.
							</p>
                        </div>
                    }
                    image="step-5"
                />
                <WizardStep
                    title={ this.state.title }
                    text={ this.state.text }
                    navigateTo="generating"
                    buttonText="Generate"
                    actionType="Rewards"
                    disabledButton={
                        this.props.selectedRewards.length === 6 ? "" : "disabled"
                    }>
                    <div className="rewards-counter">
                        <span
                            className={
                                this.props.selectedRewards.length <= 6 ? "current" : ""
                            }>
                            { this.props.selectedRewards.length }
                        </span>
                        <span>/</span>
                        <span
                            className={
                                this.props.selectedRewards.length === 6 ? "current" : ""
                            }>
                            6
						</span>{ " " }
                        <div className="instructions">Choose 6 options</div>
                    </div>
                    <div className="rewards-list">{ this.renderRewardsList() }</div>
                    <div className={ this.state.error ? "error showError" : "error" }>
                        Choose only 6 options!
					</div>
                </WizardStep>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedRewards: state.rewards
    };
};

export default connect(
    mapStateToProps,
    { selectRewards }
)(RewardActions);
